import React, { useContext } from 'react';

import { Container } from '../common';
import type { EventTypeEvaluationsContextType } from '../context';
import { EventTypeEvaluationsProvider } from '../context';
import { TransactionTabs } from './TransactionTabs';
import { TransactionCards } from './TransactionCards';
import { UserContext } from '~/dashboard/context';

const Transaction: React.FC<EventTypeEvaluationsContextType> = props => {
  const { isJourneyApplicationPage, evaluation } = props;
  const { featureFlags } = useContext(UserContext);
  const showTabs = (featureFlags?.ruleExplainabilityPhase ?? 0) > 0;

  return (
    <EventTypeEvaluationsProvider {...props}>
      <Container
        evaluationToken={evaluation.evaluation_token}
        entityToken={evaluation.entity_token}
        workflowToken={evaluation.application_token}
        workflowVersion={evaluation.public_version}
        style={isJourneyApplicationPage ? {
          paddingTop: 0,
        } : {}}
      >
        {showTabs ? (
          <TransactionTabs />
        ) : (
          <TransactionCards />
        )}
      </Container>
    </EventTypeEvaluationsProvider>
  );
};

export default Transaction;
